// extracted by mini-css-extract-plugin
module.exports = {"container":"OTPInput_container__3IGBi","input":"OTPInput_input__1zDXC"};